@mixin floating-label($yOffset: -60%) {
  --padding-size: calc(var(--spacer) / 2);
  --default-margin-left: calc(var(--input-padding-left) - var(--padding-size));

  position: absolute;
  top: 0px;
  transform: translateY($yOffset);

  margin-left: var(--floating-label-margin-left, var(--default-margin-left));
  padding: 0 var(--padding-size);
  max-width: 90%;
  font-size: var(--body-size-xsmall);
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  color: var(--body-text-arrows-400);
  min-height: 18px;

  &:before {
    content: "";
    position: absolute;
    background: var(--white-layout-301-level-0-elevation);
    top: auto;
    bottom: 0;
    z-index: -1;
    left: 0;
    width: 100%;
    height: 50%;
    pointer-events: none;
  }
}
